/*global define:false*/
define('plugins/password/view.js',['pluginBaseView'],
    function (PluginBaseView) {
        'use strict';

        return PluginBaseView.extend({

        });


    });

